/**
 * The type-specific half of a `find_issues` agent's settings page (the
 * intelligence agents). They have no switches of their own: detection is exact
 * rules in code, so this panel says what the agent checks and that the model
 * only words a finding already computed.
 */

import { INTELLIGENCE_AGENTS } from '../../../lib/intelligence/agentMeta';
import type { BehaviorSettingsPanelProps } from './types';

export function FindingsSettings({ agentType }: BehaviorSettingsPanelProps) {
  const labels = Object.values(INTELLIGENCE_AGENTS[agentType]?.findingTypeLabels ?? {});
  return (
    <div className="card space-y-2">
      <h3 className="text-sm font-semibold text-[var(--text-pri)]">What it checks</h3>
      <p className="text-xs text-[var(--text-ter)]">
        Detection is exact rules over the workspace record, so a finding never depends on a model being available.
        The model and prompt below only word a finding that was already computed.
      </p>
      {labels.length > 0 && (
        <p className="text-xs text-[var(--text-sec)]">Kinds of finding: {labels.join(' · ')}</p>
      )}
    </div>
  );
}
